import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SocialServiceCard from './social_service_card';
import SocialServiceCounter from './social_service_counter';
import SocialServiceTable from './social_service_table';
import useFetch from '../../hooks/useFetch';
import Spinner from '../../components/Spinner';


const SocialServiceParent = () => {
    const { category } = useParams();
   
    const {
        data,
        isLoading,
        errorMessage,
    } = useFetch(`${process.env.REACT_APP_API_URL}/socialservice/`);

 

    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="py-3 mb-4"><span className="text-muted fw-light">Social Service / {category.charAt(0).toUpperCase() + category.slice(1)}</span></h4>

                <SocialServiceCard/>
                <SocialServiceCounter/>
                <SocialServiceTable category={category}/>
            </div>
        </>
    );
}

export default SocialServiceParent;